@let ctrl = control();
<mat-form-field>
  <mat-label>G4 Kontonummer</mat-label>
  <input matInput type="number" appNoScroll [formControl]="ctrl" />
  @if (ctrl.hasError('required')) {
    <mat-error>G4 kontonummer er påkrævet</mat-error>
  }
  @if (ctrl.hasError('pattern')) {
    <mat-error>G4 kontonummer skal være et tal på 5 til 8 cifre</mat-error>
  }
  @if (ctrl.pending) {
    <ok-form-field-loading></ok-form-field-loading>
  }
</mat-form-field>
@if (ctrl.hasError('accountDoesNotExist')) {
  <ok-feedback-fail>
    <b>Vi kunne ikke finde en konto ud fra det angivne G4 kontonummer</b>
  </ok-feedback-fail>
}
@if (ctrl.valid && ctrl.value && accountDetails(); as details) {
  <ok-feedback-success>
    <div>
      Kontoen blev fundet.<br />
      Kundenavn: <b>{{ details.customer_name }}</b
      ><br />
      Telefonnummer: <b>{{ details.phone_number }}</b
      ><br />
      Adresse: <b>{{ details.address }}</b>
    </div>
  </ok-feedback-success>
}
